<div class="contenedorInt">
    <div class="contenedorIntHeader">
        <header class="FheaderInt FhInt" id="HlicitacionesInt">
            <div class="textHeader flx">
                <div class="dUno dmMedio"></div>
                <div class="dSeis dtOcho dmOnce">
                    <h1>CONSULTAS/REPORTES</h1>
                </div>
                <div class="dCinco dtDos dmMedio"></div>
            </div>
        </header>
	</div>

    <div class="FformContacto dDiez dtDiez dmOnce mt-3">
        <nav class="navbar navbar-expand navbar-light">
            <div id="navLicitaciones" class="collapse navbar-collapse d-flex flex-row-reverse">
                <ul class="navbar-nav row">
                    <li class="nav-item">
                        <a [routerLink]="['/licitaciones/administrador/familias']" class="nav-link m-1 pl-3 pr-3 ">Familias</a>
                    </li>
                    <li class="nav-item">
                        <a [routerLink]="['/licitaciones/administrador/calificacion']" class="nav-link m-1 pl-3 pr-3 ">Calificación</a>
                    </li>
                    <li class="nav-item">
                        <a [routerLink]="['/licitaciones/administrador/ofertas-de-licitacion']" class="nav-link m-1 pl-3 pr-3 "> Ofertas de Licitación</a>
                    </li>
                    <li class="nav-item">
                        <a [routerLink]="['/licitaciones/administrador/consultas-reportes']" class="nav-link m-1 pl-3 pr-3 disabled" tabindex="-1" aria-disabled="true"> Consultas/Reportes </a>
                    </li>
                    <li class="nav-item">
                        <a [routerLink]="['/licitaciones/administrador/login']" class="nav-link cerrar m-1 pl-3 pr-3 redBtn">Cerrar sesión</a>
                    </li>
                </ul>
            </div>
        </nav>
        <div class="row pb-5 mt-5">
            <div class="col-12 text-center mx-auto">

                <div class="FlstLi table-responsive">
                    <table class="Ftabla Ftablon table dDoce">
                        <tr>
                            <th scope="col" class="pl-2 pr-2">Reporte</th>
                            <th scope="col" class="pl-2 pr-2">Observaciones</th>
                        </tr>
                        <tr></tr>
                        <tbody class="tablaBlq">
                            <tr>
                                <td class="pl-2 pr-2 align-middle">Proveedores</td>
                                <td class="pl-2 pr-2 align-middle" (click)="openOne()">Consultar registros de Proveedores Activos e Inactivos</td>
                            </tr>
                            <tr></tr>
                            <tr>
                                <td class="pl-2 pr-2 align-middle">Reportes Licitación</td>
                                <td class="pl-2 pr-2 align-middle">Estadísticas por Filtros</td>
                            </tr>
                            <tr></tr>
                            <tr>
                                <td class="pl-2 pr-2 align-middle">Postulaciones</td>
                                <td class="pl-2 pr-2 align-middle" (click)="openTwo()">Licitantes participantes</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>

        <div class="col-12 alerta-big blqCtr text-center" *ngIf="this.consultaProveedoresLicitantes">
            <div class="row mb-2">
                <h3>Proveedores Licitantes</h3>
            </div>
            <form ngNativeValidate class="pb-3 row">
                <div class="row">
                    <div class="col-12 text-left mb-3">
                        <h4>Filtros y acciones</h4>
                    </div>
                    <fieldset class="form-check col-10 mt-2 mx-auto">
                        <div class="row">
                            <div class="col-12 col-md-12 col-lg-6 text-left">
                                <input type="radio" class="form-check-input" id="rangoFecha" name="Filtros" value="rangoFecha" (click)="activo='primero'"/>
                                <label for="rangoFecha" class="form-check-label">Rango de fecha</label>
                            </div>
                            <div class="col-12 col-md-12 col-lg-6 text-left">
                                <input type="radio" class="form-check-input" id="razonSocial" name="Filtros" value="razonSocial"(click)="activo='segundo'"/>
                                <label for="razonSocial" class="form-check-label">Razón social</label>
                            </div>
                            <div class="col-12 col-md-12 col-lg-6 text-left">
                                <input type="radio" class="form-check-input" id="estado" name="Filtros" value="estado" (click)="activo='tercero'"/>
                                <label for="estado" class="form-check-label">Buscar por estado</label>
                            </div>
                            <div class="col-12 col-md-12 col-lg-6 text-left">
                                <input type="radio" class="form-check-input" id="proveedores" name="Filtros" value="proveedores" (click)="activo='cuarto'"/>
                                <label for="proveedores" class="form-check-label">Todos los proveedores</label>
                            </div>
                        </div>
                    </fieldset>
                </div>
            </form>
            <div class="col-10 mt-2 mx-auto">
                <form ngNativeValidate class="pb-3 row FblqnoActivo" [ngClass]="{'FblqActivo':activo=='primero'}">
                    <div class="row">
                        <div class="form-group my-4 col-12 text-left mb-3">
                            <label for="fechaUno">Desde:&nbsp;</label>
                            <input type="date" id="fechaUno" name="fechaUno" class="mr-3" required>
                            <label for="fechaDos">Hasta:&nbsp;</label>
                            <input type="date" id="fechaDos" name="fechaDos" required>
                        </div>
                    </div>
                </form>
                <form ngNativeValidate class="pb-3 row FblqnoActivo" [ngClass]="{'FblqActivo':activo=='tercero'}">
                    <div class="row">
                        <div class="form-group my-4 col-12 col-md-12 col-lg-6 text-left">
                            <label for="estadoId">Estado</label>
                            <select name="estadoId" class="form-control" required>
                                <option>
                                    <!--{{ ciudad.ciudad }}-->
                                </option>
                            </select>
                        </div>
                    </div>
                </form>
                <form ngNativeValidate class="pb-3 row FblqnoActivo" [ngClass]="{'FblqActivo':activo=='segundo'}">
                    <div class="row">
                        <div class="form-group my-4 col-12 col-md-12 col-lg-6 text-left">
                            <label for="razonSocial">Razón social</label>
                            <input name="razonSocial" class="form-control mr-sm-2" type="search" placeholder="Razón social" aria-label="Search" required>
                        </div>
                    </div>
                </form>
                <form ngNativeValidate class="pb-3 row FblqnoActivo" [ngClass]="{'FblqActivo':activo=='cuarto'}">
                    <div class="row">
                        <div class="form-group my-4 col-12 col-md-12 col-lg-6 text-left">
                            <label for="proveedores">Proveedores</label>
                            <input  name="proveedores" class="form-control mr-sm-2" type="search" placeholder="Proveedores" aria-label="Search" required>
                        </div>
                    </div>
                </form>
            </div>
            <div class="row mb-4 mt-1">
                <h4 class="mb-3">Resultado de la consulta</h4>
                <div class="col-12 text-center mx-auto" *ngIf="this.resultadoBusqueda">
                    <div class="FlstLi table-responsive">
                        <div class="row dDoce text-right pr-2 barIcon">
                            <div class="col-8 col-sm-8 col-md-3 col-lg-2 ml-auto barIconInt">
                                <div class="row dDoce">
                                    <div class="col-6 ml-auto px-0">
                                       <a  [routerLink]="['/licitaciones/registro']" target="_blank"> <img class="ico-formulario iconClick" src="./../../../../../assets/images/icons/icono-usuario-nuevo.svg" alt="Usuario"> </a>
                                    </div>
                                    <div class="col-6 ml-auto px-0">
                                        <a href="#" data-type="excel">
                                            <img class="ico-formulario iconClick" src="./../../../../../assets/images/icons/icono-descarga.svg" alt="Descarga">
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <table class="Ftabla Ftablon table dDoce mt-5">
                            <tr>
                                <th scope="col" class="pl-2 pr-2">ID</th>
                                <th scope="col" class="pl-2 pr-2">RFC</th>
                                <th scope="col" class="pl-2 pr-2">Razón Social</th>
                                <th scope="col" class="pl-2 pr-2">Nombre</th>
                                <th scope="col" class="pl-2 pr-2">Paterno</th>
                                <th scope="col" class="pl-2 pr-2">Materno</th>
                                <th scope="col" class="pl-2 pr-2">Calle</th>
                                <th scope="col" class="pl-2 pr-2">Exterior</th>
                                <th scope="col" class="pl-2 pr-2">Interior</th>
                                <th scope="col" class="pl-2 pr-2">Colonia</th>
                                <th scope="col" class="pl-2 pr-2">Referencia</th>
                                <th scope="col" class="pl-2 pr-2">Ciudad</th>
                                <th scope="col" class="pl-2 pr-2">Estado</th>
                                <th scope="col" class="pl-2 pr-2">C.P.</th>
                                <th scope="col" class="pl-2 pr-2">Teléfono</th>
                                <th scope="col" class="pl-2 pr-2">Móvil</th>
                                <th scope="col" class="pl-2 pr-2">Correo electrónico</th>
                            </tr>
                            <tr></tr>
                            <tbody class="tablaBlq">
                                <tr>
                                    <td class="pl-2 pr-2 align-middle">1</td>
                                    <td class="pl-2 pr-2 align-middle">XAXX010101000</td>
                                    <td class="pl-2 pr-2 align-middle">ej.GUANTE SA DE CV</td>
                                    <td class="pl-2 pr-2 align-middle">ej.CARLOS CÉSAR</td>
                                    <td class="pl-2 pr-2 align-middle">ej.TORRES</td>
                                    <td class="pl-2 pr-2 align-middle">ej.DE LEÓN</td>
                                    <td class="pl-2 pr-2 align-middle">ej.2A. CERRADA DE PRIMAVERA MZ. 29 LT. 21</td>
                                    <td class="pl-2 pr-2 align-middle">ej.5</td>
                                    <td class="pl-2 pr-2 align-middle">ej.e</td>
                                    <td class="pl-2 pr-2 align-middle">ej.AMPLIACION AGUSTIN OLACHEA</td>
                                    <td class="pl-2 pr-2 align-middle">ej.CERCA DEL METRO</td>
                                    <td class="pl-2 pr-2 align-middle">ej.GUSTAVO A. MADERO</td>
                                    <td class="pl-2 pr-2 align-middle">ej.CIUDAD DE MÉXICO</td>
                                    <td class="pl-2 pr-2 align-middle">ej.01170</td>
                                    <td class="pl-2 pr-2 align-middle">ej.5512345678</td>
                                    <td class="pl-2 pr-2 align-middle">ej.5528864691</td>
                                    <td class="pl-2 pr-2 align-middle">ej.ssiestrada@drsimi.com.mx</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            <div class="col-12 mb-3">
                <button class="px-5 mx-2 my-2 FblqnoActivo" type="submit" (click)="busqueda()" [ngClass]="{'FblqActivoIn':activo=='primero'||activo=='segundo'||activo=='tercero'||activo=='cuarto'}">Buscar</button>
                <button class="px-5 mx-2 my-2 redBtn" (click)="cancel()"> Salir</button>
            </div>
        </div>
        <div class="col-12 alerta-big blqCtr text-center" *ngIf="this.consultaLicitantes">
            <div class="row mb-2">
                <h3>Licitantes</h3>
            </div>
            <form ngNativeValidate class="pb-3 row">
                <div class="col-12 text-left mb-3">
                    <h4>Filtros y acciones</h4>
                </div>
                <div class="form-group my-4 mb-3 mx-auto col-10 text-left" [ngClass]="{'FblqActivo':activo=='primero'}">
                    <div class="row">
                        <div class=" col-12 col-md-12 col-lg-6 pl-0">
                            <label for="fechaUno">Desde:&nbsp;</label>
                            <input type="date" id="fechaUno" name="fechaUno" class="mr-3">
                        </div>
                        <div class="col-12 col-md-12 col-lg-6 pl-0">
                            <label for="fechaDos">Hasta:&nbsp;</label>
                            <input type="date" id="fechaDos" name="fechaDos">
                        </div>
                    </div>
                </div>
                <fieldset class="form-check col-10 mt-2 mx-auto">
                    <div class="row">
                        <div class="form-check pt-1 pb-3 col-12 col-md-12 col-lg-6 text-left">
                            <input name="Filtros" type="radio" id="familia" required class="form-check-input" (click)="activo='primero'">
                            <label for="Filtros" class="form-check-label">&nbsp;&nbsp;Familia</label>
                        </div>
                        <div class="form-check pt-1 pb-3 col-12 col-md-12 col-lg-6 text-left">
                            <input name="Filtros" type="radio" id="todos" required class="form-check-input" (click)="activo='segundo'">
                            <label for="Filtros" class="form-check-label">&nbsp;&nbsp;Todos</label>
                        </div>
                    </div>
                    <div ngNativeValidate class="pb-3 row FblqnoActivo" [ngClass]="{'FblqActivo':activo=='primero'}">
                        <form>
                            <div class="row">
                                <div class="col-12 col-md-12 col-lg-6 text-left my-2 px-1">
                                    <select ngModel="familiaId" name="familiaId" class="form-control" required>
                                        <option>
                                            <!--{{ familia.familia }}-->
                                        </option>
                                    </select>
                                </div>
                                <div class="col-12 col-md-12 col-lg-6 text-left my-2 px-1">
                                    <select ngModel="familiaId" name="familiaId" class="form-control" required>
                                        <option>
                                            <!--{{ familia.familia }}-->
                                        </option>
                                    </select>
                                </div>
                            </div>
                        </form>
                    </div>
                </fieldset>
            </form>
            <div class="row mb-4 mt-1">
                <h4 class="mb-3">Resultado de la consulta</h4>

                <div class="col-12 text-center mx-auto" *ngIf="this.resultadoBusqueda">
                    <div class="FlstLi table-responsive">
                        <div class="row dDoce text-right pr-2 barIcon">
                            <div class="col-8 col-sm-8 col-md-3 col-lg-2 ml-auto barIconInt">
                                <div class="row dDoce">
                                    <div class="col-6 ml-auto px-0" *ngIf="this.usuario">
                                        <img class="ico-formulario iconClick" src="./../../../../../assets/images/icons/icono-usuario.svg" alt="Usuario" (click)="userEdit()">
                                    </div>
                                    <div class="col-6 ml-auto px-0">
                                        <a href="#" data-type="excel">
                                            <img class="ico-formulario iconClick" src="./../../../../../assets/images/icons/icono-descarga.svg" alt="Descarga">
                                        </a>
                                    </div>
                                </div>
                            </div>
                            
                        </div>
                        <table class="Ftabla Ftablon table dDoce mt-5">
                            <tr>
                                <th scope="col" class="pl-2 pr-2">Fecha</th>
                                <th scope="col" class="pl-2 pr-2">RFC</th>
                                <th scope="col" class="pl-2 pr-2">Razón Social</th>
                                <th scope="col" class="pl-2 pr-2">Familia</th>
                                <th scope="col" class="pl-2 pr-2">Producto</th>
                                <th scope="col" class="pl-2 pr-2">Observaciones</th>
                            </tr>
                            <tr></tr>
                            <tbody class="tablaBlq">
                                <tr>
                                    <td class="pl-2 pr-2 align-middle" (dblclick)="change()">05/07/2021</td>
                                    <td class="pl-2 pr-2 align-middle" (dblclick)="change()">XAXX010101000</td>
                                    <td class="pl-2 pr-2 align-middle" (dblclick)="change()" (click)="user()" [ngClass]="status ? 'success' : 'focusText'">CARLOS CÉSAR TORRES DE LEÓN</td>
                                    <td class="pl-2 pr-2 align-middle" (dblclick)="change()">Uniforme</td>
                                    <td class="pl-2 pr-2 align-middle" (dblclick)="change()">Camisa</td>
                                    <td class="pl-2 pr-2 align-middle" (dblclick)="change()">Observaciones</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            <div class="col-12 mb-3">
                <button class="px-5 mx-2 my-2 FblqnoActivo" type="submit" (click)="busqueda()" [ngClass]="{'FblqActivoIn':activo=='primero'}">Buscar</button>
                <button class="px-5 mx-2 my-2 redBtn" (click)="cancel()"> Salir</button>
            </div>
        </div>
        <div class="col-12 alerta-big blqCtr text-center" *ngIf="this.editar">
            <div class="row mb-2">
                <h3 class="text-left">Licitación calificación <br> <span class="my-5 mx-5"><small>Detalle</small></span> </h3>
            </div>
            <form ngNativeValidate class="pb-3 row dDoce">
                <div class="row dDoce">
                    <form ngNativeValidate class="pb-3 py-0 dDiez mx-auto">
                        <div class="form-group my-4 text-left row">
                            <label for="proveedor" class="col-3" >Proveedor:</label>
                            <div class="col-9">
                                <input name="proveedor" class="form-control mr-sm-2" type="text" placeholder="Proveedor" aria-label="Search" required>
                            </div>
                        </div>
                        <div class="form-group my-4 text-left row">
                            <label for="rfc" class="col-3">RFC:</label>
                            <div class="col-9">
                                <input name="rfc" class="form-control mr-sm-2" type="text" placeholder="RFC" aria-label="Search" required>
                            </div>
                        </div>
                        <div class="form-group my-4 text-left row">
                            <label for="producto" class="col-3">Producto:</label>
                            <div class="col-9">
                                <input name="producto" class="form-control mr-sm-2" type="text" placeholder="Producto" aria-label="Search" required>
                            </div>
                        </div>
                        <div class="form-group my-4 text-left row">
                            <label for="familia" class="col-3">Familia:</label>
                            <div class="col-9">
                                <input name="familia" class="form-control mr-sm-2" type="text" placeholder="Familia" aria-label="Search" required>
                            </div>
                        </div>
                        <div class="form-group my-4 text-left row">
                            <label for="calificacion" class="col-3">Calificación:</label>
                            <div class="col-9">
                                <select name="calificacion" class="form-control">
                                    <option> 
                                        <!--{{ calificacion.calificacion }}-->
                                    </option>
                                </select>
                            </div>
                        </div>
                        <div class="col-12">
                            <button type="submit" class="mr-2" (click)="confirmacion()"> Guardar y Salir</button>
                            <button class="ml-2 redBtn" (click)="cancelEditar()"> Cancelar</button>
                        </div>
                    </form>
                </div>
            </form>
        </div>

		<div class="col-12 alerta-big blqCtr text-center" *ngIf="this.usuarioEditar">
            <div class="row mb-2">
                <h3>Registro proveedor</h3>
            </div>
                <form ngNativeValidate class="pb-3 row">
                    <div class="form-row">
                        <div class="form-group col-6 text-left">
                            ID: 1
                        </div>
                        <div class="form-check col-6 pt-1 pb-3 col-12 ml-3 text-left">
                            <input type="checkbox" id="deacuerdo" class="form-check-input" checked required>
                            <label id="deacuerdoLabel" for="deacuerdo" class="form-check-label">&nbsp;&nbsp;Estoy de acuerdo con el <a [routerLink]="['/aviso-de-privacidad']">Aviso de privacidad</a></label>
                        </div>
                        <div class="form-group col-6 text-left">
                            <label for="rfcescrito">RFC</label>
                            <input name="rfcescrito" type="text" class="form-control" id="rfcescrito" pattern="^[a-zA-Z]{4}[0-9]{6}[A-Za-z0-9]{2}" maxlength="12" value="XAXX010101000">
                        </div>
                        <div class="form-group col-6 text-left ">
                            <label for="razonSocial">Razón social</label>
                            <input name="razonSocial" type="text" class="form-control" value="ej.GUANTE SA DE CV">
                        </div>
                        <div class="form-group col-lg-4 col-md-6 col-6 text-left">
                            <label for="nombreContacto">Nombre del contacto</label>
                            <input name="nombreContacto" type="text" class="form-control" id="nombreContacto" value="ej.CARLOS CÉSAR">
                        </div>
                        <div class="form-group col-lg-4 col-md-6 col-6 text-left">
                            <label for="apellidoPaterno">Apellido paterno</label>
                            <input name="apellidoPaterno" type="text" class="form-control" id="apellidoPaterno" value="ej.TORRES">
                        </div>
                        <div class="form-group col-lg-4 col-md-6 col-6 text-left">
                            <label for="apellidoMaterno">Apellido materno</label>
                            <input name="apellidoMaterno" type="text" class="form-control" id="apellidoMaterno" value="ej.DE LEÓN">
                        </div>
                        <div class="form-group col-lg-4 col-md-6 col-6 text-left">
                            <label for="telefonoFijo">Teléfono fijo</label>
                            <input name="telefonoFijo" type="tel" class="form-control" id="telefonoFijo" pattern="[0-9]{10}" maxlength="10" value="ej.5512345678">
                        </div>
                        <div class="form-group col-lg-4 col-md-6 col-6 text-left">
                            <label for="telefonoMovil">Teléfono móvil</label>
                            <input name="telefonoMovil" type="tel" class="form-control" id="telefonoMovil" pattern="[0-9]{10}" maxlength="10" value="ej.5528864691">
                        </div>
                        <div class="form-group col-lg-4 col-md-6 col-6 text-left">
                            <label for="email">Correo electrónico</label>
                            <input name="email" type="email" class="form-control" id="email" value="ej.ssiestrada@drsimi.com.mx">
                        </div>
                        <div class="form-group col-6 text-left">
                            <label for="calle">Calle</label>
                            <input name="calle" type="text" class="form-control" value="ej.2A. CERRADA DE PRIMAVERA MZ. 29 LT. 21">
                        </div>
                        <div class="form-group col-lg-3 col-md-3 col-6 text-left">
                            <label for="nInterior">N. Interior</label>
                            <input name="nInterior" type="text" class="form-control" id="nInterior" value="ej.e">
                        </div>
                        <div class="form-grou col-lg-3 col-md-3 col-6 text-left">
                            <label for="nExterior">N. Exterior</label>
                            <input name="nExterior" type="text" class="form-control" id="nExterior" value="ej.5">
                        </div>

                        <div class="form-group col-6 text-left">
                            <label for="colonia">Colonia</label>
                            <input name="colonia" type="text" class="form-control" id="colonia" value="ej.AMPLIACION AGUSTIN OLACHEA">
                        </div>
                        <div class="form-group col-6 text-left">
                            <label for="referencia">Referencia</label>
                            <input name="referencia" type="text" class="form-control" id="referencia" value="ej.CERCA DEL METRO">
                        </div>


                        <div class="form-group col-lg-4 col-md-6 col-6 text-left">
                            <label for="correo">Estado</label>
                            <select name="estadoId" class="form-control">
                                <option> 
                                    <!--{{ estado.estado }}-->
                                </option>
                            </select>
                        </div>
                        <div class="form-group col-lg-4 col-md-6 col-6 text-left">
                            <label for="correo">Ciudad/Municipio</label>
                            <select name="ciudadId" class="form-control">
                                <option>
                                    <!--{{ ciudad.ciudad }}-->
                                </option>
                            </select>
                        </div>
                        <div class="form-group col-lg-4 col-md-6 col-6 text-left">
                            <label for="cp">Código Postal</label>
                            <input name="cp" type="text" class="form-control" id="cp" pattern="[0-9]{5}" value="ej.01170">
                        </div>
                        <div class="form-group col-lg-4 col-md-6 col-6 text-left">
                            <label for="giro">Giro de la empresa</label>
                            <input name="giro" type="text" class="form-control" id="giro" value="ej.ventas">
                        </div>

                        <div class="form-group col-lg-4 col-md-6 col-6 text-left">
                            <label for="altaRegistro">Alta de registro</label>
                            <input name="altaRegistro" type="date" class="form-control" id="dateRecord">
                        </div>
                        <div class="form-group col-lg-4 col-md-6 col-6 text-left">
                            <label for="updateRegistro">Última modificación</label>
                            <input name="updateRegistro" type="date" class="form-control" id="dateUpDate">
                        </div>
                    </div>
                    <div class="form-row upload pb-1">
                        <div class="form-group col-10 text-left">
                            <label for="cvEmpresarial">CV empresarial</label>
                            <input type="file" accept="application/pdf" class="form-control-file" id="cvEmpresarial">
                        </div>
                        <div class="form-group col-1 text-center">
                            <div class="hCien">
                                <a href="#" download>
                                    <img src="./../../../../assets/images/ficha-tecnica.svg" class="ficha">
                                </a>
                            </div>
                        </div>
                        <div class="form-group col-1 text-center">
                            <div class="hCien">
                                <a href="#" download>
                                    <img src="./../../../../assets/images/icons/ficha-archivo.svg" class="ficha">
                                </a>
                            </div>
                        </div>

                        <div class="form-group col-10 text-left">
                            <label for="domicilioFiscal">Comprobante de domicilio fiscal</label>
                            <input type="file" accept="application/pdf" class="form-control-file" id="domicilioFiscal">
                        </div>
                        <div class="form-group col-1 text-center">
                            <div class="hCien">
                                <a href="#" download>
                                    <img src="./../../../../assets/images/ficha-tecnica.svg" class="ficha">
                                </a>
                            </div>
                        </div>
                        <div class="form-group col-1 text-center">
                            <div class="hCien">
                                <a href="#" download>
                                    <img src="./../../../../assets/images/icons/ficha-archivo.svg" class="ficha">
                                </a>
                            </div>
                        </div>

                        <div class="form-group col-10 text-left">
                            <label for="situacionFiscal">Comprobante de situación fiscal</label>
                            <input type="file" accept="application/pdf" class="form-control-file" id="situacionFiscal">
                        </div>
                        <div class="form-group col-1 text-center">
                            <div class="hCien">
                                <a href="#" download>
                                    <img src="./../../../../assets/images/ficha-tecnica.svg" class="ficha">
                                </a>
                            </div>
                        </div>
                        <div class="form-group col-1 text-center">
                            <div class="hCien">
                                <a href="#" download>
                                    <img src="./../../../../assets/images/icons/ficha-archivo.svg" class="ficha">
                                </a>
                            </div>
                        </div>

                        <div class="form-group col-10 text-left">
                            <label for="estadoCuenta">Estado de cuenta</label>
                            <input type="file" accept="application/pdf" class="form-control-file" id="estadoCuenta">
                        </div>
                        <div class="form-group col-1 text-center">
                            <div class="hCien">
                                <a href="#" download>
                                    <img src="./../../../../assets/images/ficha-tecnica.svg" class="ficha">
                                </a>
                            </div>
                        </div>
                        <div class="form-group col-1 text-center">
                            <div class="hCien">
                                <a href="#" download>
                                    <img src="./../../../../assets/images/icons/ficha-archivo.svg" class="ficha">
                                </a>
                            </div>
                        </div>

                        <div class="form-group col-10 text-left">
                            <label for="rfc">RFC</label>
                            <input type="file" accept="application/pdf" class="form-control-file" id="rfc">
                        </div>
                        <div class="form-group col-1 text-center">
                            <div class="hCien">
                                <a href="#" download>
                                    <img src="./../../../../assets/images/ficha-tecnica.svg" class="ficha">
                                </a>
                            </div>
                        </div>
                        <div class="form-group col-1 text-center">
                            <div class="hCien">
                                <a href="#" download>
                                    <img src="./../../../../assets/images/icons/ficha-archivo.svg" class="ficha">
                                </a>
                            </div>
                        </div>

                        <div class="form-group col-10 text-left">
                            <label for="ine">INE (Representante legal)</label>
                            <input type="file" accept="application/pdf" class="form-control-file" id="ine">
                        </div>
                        <div class="form-group col-1 text-center">
                            <div class="hCien">
                                <a href="#" download>
                                    <img src="./../../../../assets/images/ficha-tecnica.svg" class="ficha">
                                </a>
                            </div>
                        </div>
                        <div class="form-group col-1 text-center">
                            <div class="hCien">
                                <a href="#" download>
                                    <img src="./../../../../assets/images/icons/ficha-archivo.svg" class="ficha">
                                </a>
                            </div>
                        </div>
    
                        <div class="form-group col-10 text-left">
                            <label for="imss">Evaluación del IMSS</label>
                            <input type="file" accept="application/pdf" class="form-control-file" id="imss">
                        </div>
                        <div class="form-group col-1 text-center">
                            <div class="hCien">
                                <a href="#" download>
                                    <img src="./../../../../assets/images/ficha-tecnica.svg" class="ficha">
                                </a>
                            </div>
                        </div>
                        <div class="form-group col-1 text-center">
                            <div class="hCien">
                                <a href="#" download>
                                    <img src="./../../../../assets/images/icons/ficha-archivo.svg" class="ficha">
                                </a>
                            </div>
                        </div>
    
                        <div class="form-group col-10 text-left">
                            <label for="foto">Foto de la fachada de la empresa</label>
                            <input type="file" accept="application/pdf, image/*" class="form-control-file" id="foto">
                        </div>
                        <div class="form-group col-1 text-center">
                            <div class="hCien">
                                <a href="#" download>
                                    <img src="./../../../../assets/images/ficha-tecnica.svg" class="ficha">
                                </a>
                            </div>
                        </div>
                        <div class="form-group col-1 text-center">
                            <div class="hCien">
                                <a href="#" download>
                                    <img src="./../../../../assets/images/icons/ficha-archivo.svg" class="ficha">
                                </a>
                            </div>
                        </div>

                    </div>
                    <div class="col-12">
                        <button type="submit" class="mr-2" (click)="confirmacionUsuario()"> Guardar y Salir</button>
                        <button class="ml-2 redBtn" (click)="cancelEditar()"> Cancelar</button>
                    </div>
                </form>
		</div>

        <div class="col-12 alerta-exito blqCtr text-center" *ngIf="this.success">
            <img class="ico-formulario" src="./../../../../assets/images/icons/icono-warning.png">
            <p>¿La información que ingreso es correcta?</p>
            <button class="btn-confirmar mr-2" (click)="closeok()">Aceptar</button>
            <button class="ml-2 redBtn" (click)="closefail()"> Cancelar</button>
        </div>

	</div>

</div>